<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import ChannelService from "./util/ChannelTalk.js";

    export let currentRoute;
    export let params;
    let timestamp = Date.now();
    let iframe;
    let chatId = currentRoute.namedParams.chatId;
	let float = currentRoute.queryParams.float || 0;
	let story = currentRoute.queryParams.story || "flex";
    let url = "about:blank";
	let isLoad = true;
    onMount(() => {
        ChannelIO('shutdown');
        /*
        PRConnect.send("/api/Message/viewBotInfo", {botId}, data => {
            let charInfo = data.result;
       
            if( charInfo.charType === "3D") {
                url += "&gltf=" + charInfo.gltfContent;
            }
            
            iframe.src = url;
        });
        */
        url = `/static/avatalk/chats/${chatId}/prd/index.html?timestamp=${timestamp}&float=${float}&story=${story}`;
        // if (botId.includes("@")) {
		// 	isLoad = false;
        //     PRConnect.send("/api/Bot/getBotByDesignateUrl", { designateUrl : botId.split("@")[1]}, data => {
        //         document.querySelector("title").innerHTML = data.result.title + " - AVATALK";
        //         url = `/static/avatalk/${data.result.id}/prd/index.html?timestamp=${timestamp}`;
		// 		isLoad = true;
        //     });
        // } else {
        //     PRConnect.send("/api/Bot/getBotByBotId", { id : botId, log : "ACCESS"}, data => {
        //         if( data.header.status === "success") {
        //             document.querySelector("title").innerHTML = data.result.title + " - AVATALK";
        //         }
        //     });
        // }
		const setViewportHeight = () => {
			const vh = window.innerHeight * 0.01; // 1vh에 해당하는 픽셀 값을 계산
			document.documentElement.style.setProperty('--vh', `${vh}px`); // CSS 변수에 저장
		};

		// 페이지 로드 및 리사이즈 이벤트에 추가
		setViewportHeight();
		window.addEventListener('resize', setViewportHeight);
    });
    ChannelIO('shutdown');
</script>
<div class="wrapper">
	{#if isLoad}
    <iframe bind:this={iframe} src="{url}" frameBorder="0" class="iframe" scrolling="no" referrerpolicy="no-referrer" />
	{/if}
</div>

<style>
.wrapper > iframe {
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
}
::-webkit-scrollbar {
  display: none;
}

</style>